import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import BBSocialMediaEmbedFacebook from './BBSocialMediaEmbedFacebook';
import BBSocialMediaEmbedInstagram from './BBSocialMediaEmbedInstagram';
import BBSocialMediaEmbedTwitter from './BBSocialMediaEmbedTwitter';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

// TODO: use CSS modules.
const BBSocialMediaEmbed = ({
  alignment = 'center',
  provider,
  behaviorSettings = null,
  uuid = null,
  ...props
}) => {
  const ref = useRef();

  useEffect(() => {
    const elem = ref.current;

    if (!elem) {
      return;
    }

    // Create a mutation observer to watch for appearance of the social network
    // iframe. If/when the iframe is inserted into the DOM, we will
    // the props to the iframe wrapper div to give us more control over
    // styling.
    const observer = new MutationObserver(() => {
      const iframe = elem.querySelector('iframe');

      if (iframe) {
        iframe.title = `Embedded ${provider} post`;
        iframe.ariaLabel = `Embedded ${provider} post`;
        observer.disconnect();
      }
    });

    // Assign an observer.
    observer.observe(elem, { childList: true, subtree: true });

    // Clean up the observer when the component unmounts
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  props.postID = props.postID ?? '';
  props.postURL = props.postURL ?? '';

  const classes = [
    'bb',
    styles['bb-social-media-embed'],
    provider,
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid} ref={ref}>
      <div className="container">
        <div className={styles[`bb-social-media-embed--align-items-${alignment}`]}>
          {provider === 'facebook' && (
            <BBSocialMediaEmbedFacebook {...props} socialMediaType={provider} />
          )}

          {provider === 'instagram' && (
            <BBSocialMediaEmbedInstagram {...props} socialMediaType={provider} />
          )}

          {provider === 'twitter' && (
            <BBSocialMediaEmbedTwitter {...props} socialMediaType={provider} />
          )}
        </div>
      </div>
    </div>
  );
};

BBSocialMediaEmbed.propTypes = {
  provider: PropTypes.oneOf(['facebook', 'instagram', 'twitter']).isRequired,
  postURL: PropTypes.string,
  postID: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'right', 'center', undefined]),
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBSocialMediaEmbed;
